import { msg } from "@lingui/core/macro"
import { useLingui } from "@lingui/react"
import { Trans } from "@lingui/react/macro"
import { Alert, Button, Group, Text } from "@mantine/core"
import type { IProps } from "./interfaces"

/**
 * Banner shown when an interrupted recording is recovered from IndexedDB on
 * mount. Three-action choice: pick up where it left off, finalize the captured
 * audio as-is, or discard. No age limit — any unsubmitted recording is worth
 * recovering.
 */
export const RecoveryBanner = ({
  durationLabel,
  sizeMB,
  monitoring,
  onResume,
  onSubmit,
  onDiscard,
  submitting = false,
}: IProps): React.JSX.Element => {
  const { i18n } = useLingui()

  return (
    <Alert color="warning" variant="light" title={i18n._(msg`Recording recovered`)} mb="md">
      <Text size="sm" mb="sm">
        <Trans>
          Found {durationLabel} of audio ({sizeMB} MB) from an interrupted recording.
        </Trans>
      </Text>
      <Group>
        <Button size="sm" onClick={onResume} disabled={!monitoring || submitting}>
          <Trans>Resume</Trans>
        </Button>
        <Button size="sm" variant="light" onClick={onSubmit} loading={submitting}>
          <Trans>Submit as-is</Trans>
        </Button>
        <Button size="sm" variant="subtle" color="danger" onClick={onDiscard} disabled={submitting}>
          <Trans>Discard</Trans>
        </Button>
      </Group>
    </Alert>
  )
}
